/* KUPI ODMAH na karticama: EasySell forma samo sa kliknutim proizvodom */
(function(){
  var KEY='msRestoreCart';
  function bubble(count){
    var b=document.getElementById('cart-icon-bubble');if(!b)return;
    var n=b.querySelector('.cart-count-bubble');
    if(count<1){if(n)n.remove();return}
    if(!n){n=document.createElement('div');n.className='cart-count-bubble';b.appendChild(n)}
    n.innerHTML='<span aria-hidden="true">'+count+'</span>';
  }
  function json(u,o){return fetch(u,o).then(function(r){if(!r.ok)throw new Error(u);return r.json()})}
  function post(u,body){return json(u,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body||{})})}
  function getSaved(){try{return JSON.parse(sessionStorage.getItem(KEY)||'null')}catch(e){return null}}
  function setSaved(v){try{v?sessionStorage.setItem(KEY,JSON.stringify(v)):sessionStorage.removeItem(KEY)}catch(e){}}
  var memSaved=null;
  function restore(){
    var saved=memSaved||getSaved();memSaved=null;setSaved(null);
    if(!saved)return Promise.resolve();
    return post('/cart/clear.js').then(function(){
      return saved.length?post('/cart/add.js',{items:saved}):null;
    }).then(function(){return json('/cart.js')}).then(function(c){bubble(c.item_count)}).catch(function(){});
  }
  function addBuy(root){
    (root||document).querySelectorAll('.card-wrapper div.quick-add').forEach(function(q){
      var card=q.closest('.card-wrapper');
      if(!card||card.querySelector('.ms-buynow'))return;
      if(q.querySelector('button[disabled]')){q.classList.add('ms-soldout');return}
      var a=card.querySelector('.card__heading a, a.full-unstyled-link');
      if(!a)return;
      var href=a.getAttribute('href').split('#')[0];
      var b=document.createElement('a');
      b.className='ms-buynow button button--full-width';
      b.href=href+(href.indexOf('?')>-1?'&':'?')+'kupi=1';
      b.innerHTML='<span>KUPI ODMAH</span>';
      q.insertBefore(b,q.firstChild);
      var mo=q.querySelector('modal-opener');
      if(mo){
        var o=document.createElement('a');
        o.className='quick-add__submit button button--full-width button--secondary ms-options';
        o.href=href;o.innerHTML='<span>Izaberi opciju</span>';
        mo.replaceWith(o);
      }
    });
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.ms-buynow');if(!b)return;
    var card=b.closest('.card-wrapper');
    var idInput=card&&card.querySelector('form.quick-add input[name=id]');
    var es=document.querySelector('.es-popup-button-drawer')||document.querySelector('#es-popup-button');
    if(!idInput||!es)return;
    e.preventDefault();
    if(b.classList.contains('loading'))return;
    b.classList.add('loading');
    var vid=+idInput.value;
    json('/cart.js').then(function(c){
      var only=c.items.length===1&&c.items[0].variant_id===vid&&c.items[0].quantity===1;
      if(only)return;
      if(c.items.length&&!getSaved()){
        memSaved=c.items.map(function(i){var o={id:i.variant_id,quantity:i.quantity};if(i.properties&&Object.keys(i.properties).length)o.properties=i.properties;return o});
        setSaved(memSaved);
      }
      return post('/cart/clear.js').then(function(){return post('/cart/add.js',{items:[{id:vid,quantity:1}]})});
    }).then(function(){return json('/cart.js')}).then(function(c){
      bubble(c.item_count);
      es.click();
    }).catch(function(){location.href=b.href})
      .finally(function(){b.classList.remove('loading')});
  },true);
  function watchModal(){
    var m=document.getElementById('easysell-modal');
    if(!m){if(watchModal.n++<60)setTimeout(watchModal,500);return}
    var wasOpen=false;
    new MutationObserver(function(){
      var open=getComputedStyle(m).display!=='none';
      if(wasOpen&&!open&&(memSaved||getSaved()))restore();
      wasOpen=open;
    }).observe(m,{attributes:true,attributeFilter:['style','class']});
    if(getSaved()&&getComputedStyle(m).display==='none')restore();
  }
  watchModal.n=0;
  function autoOpen(){
    if(!/[?&]kupi=1/.test(location.search))return;
    var meta=window.ShopifyAnalytics&&ShopifyAnalytics.meta&&ShopifyAnalytics.meta.product;
    var multi=meta&&meta.variants&&meta.variants.length>1;
    try{history.replaceState(null,'',location.pathname+location.search.replace(/([?&])kupi=1&?/,'$1').replace(/[?&]$/,'')+location.hash)}catch(e){}
    var target=document.querySelector('[data-ms-buy]')||document.querySelector('product-form button[name=add]');
    function scrollTo(){if(target){(target.closest('form')||target).scrollIntoView({behavior:'smooth',block:'center'})}}
    if(multi){scrollTo();return}
    var n=0;(function tryOpen(){
      var es=document.querySelector('.es-popup-button-product');
      if(es){setTimeout(function(){es.click()},400);return}
      if(n>30){scrollTo();return}
      n++;setTimeout(tryOpen,200);
    })();
  }
  function start(){
    addBuy();
    new MutationObserver(function(ms){ms.forEach(function(m){m.addedNodes.forEach(function(x){if(x.nodeType===1&&x.querySelector&&x.querySelector('div.quick-add'))addBuy(x)})})}).observe(document.body,{childList:true,subtree:true});
    watchModal();
    if(document.readyState==='complete')autoOpen();else window.addEventListener('load',autoOpen);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
